import axios from '@/plugins/axios'

const apiEndPoint = 'admin/sales-agent'

export default {
    namespaced: true,

    state: {
        requestlist: [],
        daterange: [],
        requestdetail: {},
        page: 0,
        startdate: new Date(new Date().setDate(new Date().getDate() - 30)).toISOString(),
        enddate: new Date().toISOString(),
        option: {
            isVerified: 'waiting'
        }
    },

    getters: {

    },

    mutations: {
        setRequestlist (state, requestlist) {
            state.requestlist = requestlist
        },
        setRequestdetail (state, saleAgent) {
            state.requestdetail = saleAgent
        },
        setOption (state, optionData) {
            state.option = optionData
        },
        setStartdate (state, sDate) {
            state.startdate = sDate
        },
        setEnddate (state, eDate) {
            state.enddate = eDate
        },
        setPage (state, ePage) {
            state.page = ePage
        }
    },

    actions: {
        async fetchRequestlist (context) {
            const response = await axios.post(`${apiEndPoint}?startDate=${context.state.startdate}&endDate=${context.state.enddate}&page=${context.state.page}&perPage=50`, context.state.option)
            const requestlist = response
            context.commit('setRequestlist', requestlist.content)
            var calTotal = response.totalItems / 50
            this.totalPage = Math.ceil(calTotal)
            return Math.ceil(calTotal)
        },

        async patchRequestlist (context) {
            const response = await axios.patch(`${apiEndPoint}/${context.state.requestdetail.id}`, context.state.requestdetail)
            const patchUpdate = response
            console.log(patchUpdate)
        },

        async deleteRequest (context) {
            const response = await axios.delete(`sales-agent/${context.state.requestdetail.id}`)
            const patchUpdate = response
            console.log(patchUpdate)
        }
    }
}
